import {IUpdatePassword} from '../../../coreGlobal/models/user'

export const BuildRequestPassword = async (data: IUpdatePassword) => {
  return {
    current_password: data.currentPassword,
    password: data.newPassword,
    password_confirmation: data.passwordConfirmation,
  }
}
